import { useEffect, useState } from "react";

import { ReservesChart } from "~/components/charts/reserves";
import type { Attestation, Token } from "~/lib/stablecoins.server";
import { publicTickers } from "~/routes/stablecoins/$ticker";

export const hasAttestationGraph = (ticker: string) =>
  publicTickers.has(ticker);

export const AttestationsGraphs = (token: Token) => {
  const [attestations, setAttestations] = useState<Attestation[]>([]);

  useEffect(() => {
    (async () => {
      setAttestations(
        await (
          await fetch(`https://app.brale.xyz/api/attestations/${token.ticker}`)
        ).json()
      );
    })();
  }, [token]);

  return <>{ReservesChart(token.ticker, attestations)}</>;
};
